export default __webpack_public_path__ + "static/media/06_DAIF_Security_01_loop.209c4f52.mp4";